function formatAplicaciones(aplicaciones) {
  if (!aplicaciones) return '';

  let list = [];
  if (Array.isArray(aplicaciones)) {
    list = aplicaciones.map(app => {
      if (typeof app === 'string') return app;
      if (app && typeof app === 'object') return app.vehiculo_completo || '';
      return '';
    }).filter(Boolean);

    list = list.join('; ').split('; ');
  } else {
    list = String(aplicaciones).split(/;\s*/).filter(Boolean);
  }

  const grouped = {};

  list.forEach(app => {
    if (!app) return;

    let cleaned = app.replace(/\(-\)/g, '').trim();
    if (!cleaned || cleaned === '-') return;

    const parts = cleaned.split(' ');
    const marca = parts[0];

    if (parts.length < 2) return;

    let model = parts.slice(1).join(' ');
    model = model.replace(/\(-\)/g, '').trim();
    if (!model || model === '-') return;

    if (!grouped[marca]) grouped[marca] = [];

    const truncatedModel = model.length > 15 ? `${model.substring(0, 15)}...` : model;

    if (!grouped[marca].includes(truncatedModel)) {
      grouped[marca].push(truncatedModel);
    }
  });

  const entries = Object.keys(grouped).map(marca => {
    const models = grouped[marca].join(', ');
    if (!models) return '';
    return `${marca} ${models}`;
  }).filter(Boolean);

  if (entries.length === 0) return '';

  const formatted = entries.join(' / ');
  return formatted.length > 60 ? `${formatted.substring(0, 57)}...` : formatted;
}

export default formatAplicaciones;
